import { createComponent } from '@carvana/merch-components';

export const ActionsContainer = createComponent('div', {
  className: 'flex items-center u:gap-md'
});
